import { createUseStyles } from 'react-jss'

export const style = {
  description: {
    whiteSpace: 'pre-line',
    composes: 'report-full-width',
    textAlign: 'center',
    maxWidth: 840,
    margin: '0 auto',
    letterSpacing: (props) => props.variant === 'executiveSummary' ? 1.5 : 1,
    fontSize: (props) => props.variant === 'executiveSummary' ? 18 : 16
  }
}

export const useStyles = createUseStyles(style)
